import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });
const base = "/report-cards-portal";

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

/* Grade schemes */
export const createGradeSchemePortal = async (data) =>
  (await axiosInstance.post(`${base}/grade-schemes/create`, data)).data;
export const getAllGradeSchemesPortal = async (filters = {}) =>
  (await axiosInstance.get(`${base}/grade-schemes/all${qs(filters)}`)).data;
export const getGradeSchemeByIdPortal = async (id) =>
  (await axiosInstance.get(`${base}/grade-schemes/${id}`)).data;
export const updateGradeSchemePortal = async (id, data) =>
  (await axiosInstance.put(`${base}/grade-schemes/update/${id}`, data)).data;
export const deleteGradeSchemePortal = async (id) =>
  (await axiosInstance.delete(`${base}/grade-schemes/delete/${id}`)).data;
export const previewGradePortal = async (schemeId, percentage) =>
  (
    await axiosInstance.get(
      `${base}/grade-schemes/preview${qs({ schemeId, percentage })}`
    )
  ).data;

/* Templates */
export const createTemplatePortal = async (data) =>
  (await axiosInstance.post(`${base}/templates/create`, data)).data;
export const getAllTemplatesPortal = async (filters = {}) =>
  (await axiosInstance.get(`${base}/templates/all${qs(filters)}`)).data;
export const getTemplateByIdPortal = async (id) =>
  (await axiosInstance.get(`${base}/templates/${id}`)).data;
export const updateTemplatePortal = async (id, data) =>
  (await axiosInstance.put(`${base}/templates/update/${id}`, data)).data;
export const deleteTemplatePortal = async (id) =>
  (await axiosInstance.delete(`${base}/templates/delete/${id}`)).data;

/* Batches */
export const getMarksSourcePreviewPortal = async (filters = {}) =>
  (await axiosInstance.get(`${base}/source-preview${qs(filters)}`)).data;
export const createBatchPortal = async (data) =>
  (await axiosInstance.post(`${base}/batches/create`, data)).data;
export const getAllBatchesPortal = async (filters = {}) =>
  (await axiosInstance.get(`${base}/batches/all${qs(filters)}`)).data;
export const getBatchByIdPortal = async (id) =>
  (await axiosInstance.get(`${base}/batches/${id}`)).data;
export const generateBatchPortal = async (id) =>
  (await axiosInstance.post(`${base}/batches/generate/${id}`)).data;
export const publishBatchPortal = async (id) =>
  (await axiosInstance.post(`${base}/batches/publish/${id}`)).data;
export const unpublishBatchPortal = async (id) =>
  (await axiosInstance.post(`${base}/batches/unpublish/${id}`)).data;
export const deleteBatchPortal = async (id) =>
  (await axiosInstance.delete(`${base}/batches/delete/${id}`)).data;

/* Cards */
export const getReportCardByIdPortal = async (id) =>
  (await axiosInstance.get(`${base}/cards/${id}`)).data;
export const updateReportCardRemarksPortal = async (id, data) =>
  (await axiosInstance.put(`${base}/cards/remarks/${id}`, data)).data;
export const getReportCardPrintPayloadPortal = async (id) =>
  (await axiosInstance.get(`${base}/cards/${id}/print`)).data;

/** HTML view URL (new tab / iframe) */
export const getReportCardHtmlUrlPortal = (id) =>
  `${API}${base}/cards/${id}/html`;

/** Direct PDF URL (optional) */
export const getReportCardPdfUrlPortal = (id) =>
  `${API}${base}/cards/${id}/pdf`;

/** Download PDF as Blob (use with createObjectURL) */
export const downloadReportCardPdfPortal = async (id) => {
  const res = await axiosInstance.get(`${base}/cards/${id}/pdf`, {
    responseType: "blob",
  });
  return res.data;
};
